import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import {V1ProjectPlanPhaseApprovalIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";


class ProjectPlanPhaseApprovalEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.ProjectPlanPhaseApproval-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectPlanPhaseApproval-001";

        let fk = {};
        fk["ProjectPlanPhaseUSID"] = foreignKey;

        AxiosFoundationAPI({
            method: "GET",
            url: "t1/v1/project_plan_phase_approvals",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...(foreignKey ? fk : {}),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanPhaseApprovalIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.ProjectPlanPhaseApproval-001";
        payload.PlatformMessage.ProjectPlanPhaseApproval = this.preparePUTPayload();

        return payload;
    };

    performUpdate = () => {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t1/v1/project_plan_phase_approvals",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseApproval-001",
                "idoc-response": "v1.ProjectPlanPhaseApproval-001",
            },
        };
        this.notifyUpdateStartListeners();
        AxiosFoundationAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1ProjectPlanPhaseApprovalIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let approval = {};

        approval["USID"] = this.getAttributeValue("USID");
        approval["ProjectPlanPhaseUSID"] = this.getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("USID")
        approval["AccountUserUSID"] = this.getAttributeValue("AccountUserUSID")
        let status = "AWAITING SUBMISSION";
        if (this.getEnterpriseObject().getEnterpriseComponent("ProjectPlanPhase").getAttributeValue("Status") === "IN REVIEW") {
            status = "AWAITING APPROVAL"
        }
        approval["Status"] = status;

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.ProjectPlanPhaseApproval-001";
        payload.PlatformMessage.ProjectPlanPhaseApproval = approval;

        return payload;
    };

    performInsert = () => {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t1/v1/project_plan_phase_approvals",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseApproval-001",
                "idoc-response": "v1.ProjectPlanPhaseApproval-001",
            },
        };
        this.notifyInsertStartListeners();
        AxiosFoundationAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1ProjectPlanPhaseApprovalIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.ProjectPlanPhaseApproval-001";
        payload.PlatformMessage.ProjectPlanPhaseApproval = {
            "USID": this.getAttributeValue("USID")
        };

        let options = {
            method: "DELETE",
            url: "t1/v1/project_plan_phase_approvals",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.ProjectPlanPhaseApproval-001",
                "idoc-response": "v1.ProjectPlanPhaseApproval-001",
            },
        };
        this.notifyDeleteStartListeners();
        AxiosFoundationAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default ProjectPlanPhaseApprovalEnterpriseComponent;